var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "projectsToolbar" },
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                  expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                },
              ],
              attrs: { size: "md", variant: "outline-primary" },
              on: { click: _vm.initializeProjectCreateProjectModal },
            },
            [
              _c("span", { staticClass: "fa fa-plus" }),
              _vm._v(" " + _vm._s(_vm.$t("message.create_project")) + "\n    "),
            ]
          ),
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showInactiveProjects",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.showInactiveProjects,
                  callback: function ($$v) {
                    _vm.showInactiveProjects = $$v
                  },
                  expression: "showInactiveProjects",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_inactive_projects"))),
          ]),
          _c(
            "c-switch",
            _vm._b(
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showFlatView",
                  color: "primary",
                  label: "",
                  disabled: _vm.isSearching,
                  title: _vm.$t("message.switch_view"),
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.saveViewState.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.showFlatView,
                  callback: function ($$v) {
                    _vm.showFlatView = $$v
                  },
                  expression: "showFlatView",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_flat_view"))),
          ]),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: {
          "on-pre-body": _vm.onPreBody,
          "on-post-body": _vm.onPostBody,
          "on-load-success": _vm.onLoadSuccess,
        },
      }),
      _c("project-create-project-modal", {
        on: { refreshTable: _vm.refreshTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }